import initBackToTopLink from './backToTopLink';
import initSummerQuickSearchGoButton from './summerQuickSearch';
import initBookingProcessButtons from './bookingProcessButtons';
import initStickyBookingForm from './stickyBookingForm';
import { initTabs } from './tabs';
import { initAccommodationSlider } from './accommodationSlider';
import { initRecentlyViewedSlider } from './recentlyViewedSlider';
import { initMenu } from './menu';
/*import { initLeavingSiteSurvey } from './leavingSiteSurvey';*/
import { initClientAreaForm } from './clientAreaForm';
import { initAccordion } from './accordion';
import { initNewsletterSignup } from './newsletterSignup';
import initOpeningHours from './openingHours';
import { initPopularPagesSlider } from './popularPages';
import { initPropertySlider } from './propertyImageSlider';
import initBestResorts from './bestResorts';
import { initEditorialMentions } from './editorialMentions';
import { initClientReviews } from './clientReviews';
import { initDummyData } from './DummyData';
import initSocialSharing from './socialSharing';
import initSpecialOffers from './specialOffers';
import { initTickerSlider } from './tickerSlider';
import initWinterResortPageReadMore from './winterResortPageReadMore';
import { initSearchIcon } from './searchIcon';
import { bookingMetricSearchEnd } from './BookingMetricSearch';
import { initAvailProSearchGoal } from './availproSearchGoal';
import { initPhoneCallGoal } from './phoneCallGoal';
import { initBrowserCompatability } from './browserCompatibility';
import { initPreventRightClickOnBlogs } from './preventRightClickOnBlogs';
import { initCookieBar } from './cookieBar';
import { initLazyLoad } from './lazyLoad';

const pageFunctions = {
  common: {
    init() {
      
    },

    finalize() {
      
      initTabs();
      initPreventRightClickOnBlogs();
      initMenu();
      initAccommodationSlider();
      initRecentlyViewedSlider();
      initOpeningHours();
      initClientAreaForm();
      initPopularPagesSlider();
      initAccordion();
      initBestResorts();
      initNewsletterSignup();
      initPropertySlider();
   /*   initLeavingSiteSurvey();*/
      initEditorialMentions();
      initClientReviews();
      initSocialSharing();
      initDummyData();
      initBookingProcessButtons();
      initStickyBookingForm();
      initSpecialOffers();
      initBackToTopLink();
      initWinterResortPageReadMore();
      initSearchIcon();
      initTickerSlider();
      initSummerQuickSearchGoButton();
      bookingMetricSearchEnd();
      initAvailProSearchGoal();
      initPhoneCallGoal();
      initBrowserCompatability();
      initCookieBar();
      initLazyLoad();
    },
    loaded() {
      
    }
  }
};

const executePageFunctions = (finalize = false, loaded = false) => {
  const body = document.body;

  
  
  if (loaded) {
    pageFunctions.common.loaded();
  } else if (finalize && !loaded) {
    pageFunctions.common.finalize();
  } else {
    pageFunctions.common.init();
  }

  for (let c of body.classList) {
    c = c.replace(/-/g, '_');

    if (loaded) {
      if (typeof pageFunctions[c] !== 'undefined') {
        if (typeof pageFunctions[c].loaded !== 'undefined') {
          pageFunctions[c].loaded();
        }
      }
      return;
    }

    if (finalize) {
      if (typeof pageFunctions[c] !== 'undefined') {
        if (typeof pageFunctions[c].finalize !== 'undefined') {
          pageFunctions[c].finalize();
        }
      }
      return;
    }

    if (typeof pageFunctions[c] !== 'undefined') {
      if (typeof pageFunctions[c].init !== 'undefined') {
        pageFunctions[c].init();
      }
    }

  }
};

document.addEventListener('DOMContentLoaded', function () {
  executePageFunctions(true);
});

window.addEventListener('load', function () {
  executePageFunctions(true, true);
});
executePageFunctions();
